module.exports = __webpack_public_path__ + "img/CropOutlined.969e138c.svg";